export enum Salutation {
    Mr = 'Mr',
    Ms = 'Ms',
    Other = 'Other',
}
